export const MINIMUM_RESULTS_TO_SHOW_PAGINATION_OPTIONS = 11;

export const START_PAGE = 1;

export const SIZE_PER_PAGE_LIST = [10, 25, 50, 100];

export const SIZE_PER_HISTORY_PAGE_LIST = [10, 25, 50];

export const DESC = 'desc';

export const ASC = 'asc';

export const DEFAULT_TABLE_SORTING_ORDER = [DESC, ASC];

export const DEFAULT_TABLE_SORT_MODEL = { field: 'startTime', sort: 'desc' };

export const TABLE_REFRESH_TIME = 30000;

export const RESPONDER_DASHBOARD_REFRESH_MS_TIME = 60000;

export const RESPONDER_DASHBOARD_REFRESH_S_TIME = 60;

export const RESPONDER_REFRESH_BUFFER_SECONDS = 10;

export const SIXTY_SECONDS = 60;

export const ONE_SECOND = 1000;

export const COUNTDOWN_LENGTH = 5;

/* Default days value when defaultAnonymizationSetting does not return any value */
export const DEFAULT_OVERRIDE_DAYS = 2;

export const DATE_FORMAT = 'dd MMM yyyy HH:mm:ss ZZZZ';

export const DB_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const PHONETOOL_LINK_PREFIX = 'https://phonetool.amazon.com/users/';

export const ADMIN_DIRECTORY_LINK_PREFIX = 'https://admindirectory.corp.amazon.com/users/';

export const DOMAINS = {
    DEFAULT: '*'
};

export const NA = 'N/A';

export const RALLY_POINT_PERMISSIONS = {
    EVENT_OWNER: {
        OBJECT: '/rallypoint',
        ACTION: 'eventOwnerAccess'
    },
    BUSINESS: {
        OBJECT: '/rallypoint',
        ACTION: 'businessAccess'
    },
    ADMIN: {
        OBJECT: '/rallypoint',
        ACTION: 'adminAccess'
    },
    SHOW_OSR: {
        OBJECT: '/rallypoint',
        ACTION: 'showOSR'
    },
    SHOW_INCIDENT_DETAILS: {
        OBJECT: '/rallypoint',
        ACTION: 'showIncidentDetails'
    },
    SHOW_INCIDENT_HISTORY: {
        OBJECT: '/rallypoint',
        ACTION: 'showIncidentHistory'
    },
    SHOW_SITE_SHUTDOWN: {
        OBJECT: '/rallypoint',
        ACTION: 'showSiteShutdown'
    },
    SHOW_TASKLISTS: {
        OBJECT: '/rallypoint',
        ACTION: 'showTasklists'
    },
    SHOW_ADMIN: {
        OBJECT: '/rallypoint',
        ACTION: 'showAdmin'
    },
    TEST_ACCESS: {
        OBJECT: '/rallypoint',
        ACTION: 'testAccess'
    }
};

export const RALLY_POINT_ROLES = {
    ADMIN: 'Admin',
    BUSINESS: 'Business',
    EVENT_OWNER: 'EventOwner',
    USER: 'User'
};

export const STATUS_COLORS = {
    GREEN: 'green',
    GREY: 'grey'
};

export const RP_WIKI_URL =
    'https://w.amazon.com/bin/view/New_Technologies_for_Security_(NT4S)/Rally_Point/User_Guide';

export const ERROR_AUTO_CLOSE = 10000;

export const INCIDENT_TYPES = {
    DRILL: 'Drill',
    SHELTER_IN_PLACE: 'Shelter in Place',
    EVACUATION: 'Evacuation'
};

export const INCIDENT_NEW_TYPES = {
    REAL_EMERGENCY: 'Real Emergency',
    DRILL: 'Drill',
    DEMO: 'Demo'
};

export const INCIDENT_SUB_TYPES = {
    EVACUATION: 'Evacuation',
    INVACUATION: 'Invacuation',
    SHELTER_IN_PLACE: 'Shelter in Place' // deprecated, leaving in place for backwards compatibility
};

export const INCIDENT_SUB_TYPE_IDS = {
    EVACUATION: 1,
    SHELTER_IN_PLACE: 2, // deprecated, leaving in place for backwards compatibility
    INVACUATION: 3
};

export const PHONE_ANONYMIZATION_EVENT_TYPES = {
    REAL_EMERGENCY_EVACUATION: 'Real Emergency - Evacuation',
    REAL_EMERGENCY_SHELTER_IN_PLACE: 'Real Emergency - Shelter in Place',
    DRILL_EVACUATION: 'Drill - Evacuation',
    DRILL_SHELTER_IN_PLACE: 'Drill - Shelter in Place',
    DEMO_EVACUATION: 'Demo - Evacuation',
    DEMO_SHELTER_IN_PLACE: 'Demo - Shelter in Place'
};

export const DIRECT_GSOC_NUMBERS_COUNTRY = 'DEFAULT';

export const UNITED_STATES_ALPHA_2_CODE = 'us';

export const INVALID_DAYS_MESSAGE = 'You must enter a value from 0 to 365!';

export const CONFIRM_ADD_OVERRIDE_MESSAGE = 'Are you sure you want to add this override?';

export const CONFIRM_EDIT_OVERRIDE_MESSAGE = 'Are you sure you want to edit this override?';

export const CONFIRM_CHANGE_DEFAULT_OVERRIDE_MESSAGE =
    'Are you sure you want to change the default override?';

export const CONFIRM_DELETE_OVERRIDE_MESSAGE = 'Are you sure you want to delete this override?';

export const OVERRIDE_EXISTS_MESSAGE = 'An override already exists for this country!';

export const LOCAL_COUNTRY_NUMBER_EXISTS_MESSAGE = 'Local numbers already exist for this country!';

export const NEVER_ANONYMIZE_MESSAGE = 'Never';

export const CONFIRM_CHANGE_GSOC_PHONE_NUMBER_MESSAGE =
    'Are you sure you want to change the direct GSOC phone number(s)?';

export const CONFIRM_CHANGE_LOCAL_PHONE_NUMBER_MESSAGE = `Are you sure you want to change this country's local GSOC phone number(s)?`;

export const CONFIRM_ADD_LOCAL_PHONE_NUMBER_MESSAGE = `Are you sure you want to add these local GSOC phone number(s)?`;

export const ROLES_PERMISSIONS_MESSAGES = {
    USERS_TAB_MSG:
        'All Amazonians (anyone with a login, including contractors) will at a minimum have user-level access. Changes to tab access and to the following key features must go through the software development lifecycle.',
    EVENT_OWNERS_TAB_MSG:
        'Access to the Event Owner role must be requested via Site admins, who can get an ANT group associated with a permission team, mapped to the Rally point Event owner role under Resolver group in Facility Manager.',
    BUSINESS_TEAMS_TAB_MSG:
        'Business Teams have the ability to view PII at all times for all sites globally in Rally Point Web. Business Team users will default to either the User or Event Owner role in Rally Point Mobile, depending on their People Portal and Facility Manager associations. Access for new Permissions Teams to get added as business team role should be requested via SIM and have L6+ approval.',
    ADMINS_TAB_MSG: 'Admins have access to all tabs and all features and can see all PII at all times.',
    FOOTER_NOTE_ASSOCIATED:
        '*Associated = any site you are associated with in people portal or any site for which you are listed as an IMT member in Facility Manager'
};

export const EVENT_OWNERS_FOOTNOTES = {
    TITLE: 'Other populations who automatically get the Event Owner role:',
    NOTE1: 'All blue badge employees marked as a manager in People API (PAPI)',
    NOTE2: 'Anyone on an Incident Management Team (IMT) as listed in Facility Manager'
};

export const DEFAULT_ANONYMIZE_TOGGLE = {
    OFF: 'Off',
    ON: 'On'
};
export const ROLES = {
    ADMIN: 'admin',
    BUSINESS: 'business',
    EVENTOWNER: 'eventOwner',
    USER: 'user'
};
export const VIEW_ROLE_MAP = {
    admin: 'Admin',
    business: 'Business Team',
    eventOwner: 'Event Owner',
    user: 'User'
};
export const PERMISSIONS_TEAMS_EXISTS_MESSAGES = 'This Permissions team exists already!';

export const CONFIRM_ADD_PERMISSIONS_TEAMS_MESSAGE = 'Are you sure you want to add this permission team?';

export const CONFIRM_DELETE_PERMISSIONS_TEAMS_MESSAGE =
    'Are you sure you want to delete this permission team?';

export const CONFIRM_ADD_INCIDENT_REASON_MESSAGE = 'Are you sure you want to add a new event reason?';

export const CONFIRM_ADD_EMAIL_NOTIFICATION_GROUP_MESSAGE =
    'Are you sure you want to add this email notifications group?';

export const CONFIRM_DELETE_EMAIL_NOTIFICATION_GROUP_MESSAGE =
    'Are you sure you want to remove this email notifications group?';

export const RESOLVER_GROUP_KEY_EXISTS_MESSAGES = 'This Facility Manager resolver group key exists already!';

export const CONFIRM_ADD_RESOLVER_GROUP_KEY_MESSAGE = 'Are you sure you want to add this resolver group key?';

export const CONFIRM_DELETE_RESOLVER_GROUPS_KEY_MESSAGE =
    'Are you sure you want to delete this resolver group key?';

export const INVALID_ABACUSID_MESSAGE = 'Invalid Abacus Id : ';

export const DO_NOT_REMOVE_EMAIL_MESSAGE = 'You cannot edit the default email lists!';

export const VALIDATING_MESSAGE = 'Validating...';

export const SITE_SHUTDOWN_QUICK_FILTERS_TIP =
    'These shutdown states are based on PreCog data: Scheduled (planned and over 48 hours away), Upcoming (within 48 hours), Ongoing (in progress), Reopened (ended within two weeks), Completed (ended over two weeks ago), and Canceled (called off before starting).';

export const SITE_SHUTDOWN_PRECOG_TICKET_CREATION_LINK =
    'https://sim.amazon.com/issues/create?template=93812466-20f9-4fc2-a194-096a6afe1f44';

export const TASKLISTS_QUICK_FILTERS_TIP =
    'Activated: Tasklist started but no tasks completed (0% progress); In Progress: Some tasks done but not complete (0% < progress < 100%); Complete: All tasks done (100% progress); Deactivated: No updates for 2+ weeks.';

export const TABLE_FILTER_TIP = 'Filtering performs OR with same columns, AND with different columns';

export const FILTER_TIP_ICON_SIZE = 20;

export const RP_BLUE = '#0D4AFF';

export const TAB_COLOR = '#007bff';

export const INVALID_LOGIN = 'INVALID LOGIN';

export const MAX_CARDHOLDERS_PAGE_SIZE = 2000;

export const ACTIVE_GROUP_EMP_STATUS = 'A';

export const CARDHOLDER_API_RESPONSE_SCHEMA: { [key: string]: string } = {
    RESULTS: 'results',
    EMPLOYEES: 'employees',
    DATA: 'data',
    EMPID: 'empId',
    LOGIN: 'login',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'primaryEmail',
    PRIMARY_PHONE: 'primaryPhone',
    IS_PRIMARY_PHONE_PRIVATE: 'isPrimaryPhonePrivate',
    MOBILE_PHONE: 'mobilePhone',
    IS_MOBILE_PHONE_PRIVATE: 'isMobilePhonePrivate',
    HOME_PHONE: 'homePhone',
    IS_HOME_PHONE_PRIVATE: 'isHomePhonePrivate',
    OFFICE_PHONE: 'officePhone',
    IS_OFFICE_PHONE_PRIVATE: 'isOfficePhonePrivate',
    TITLE: 'title',
    LOCATION: 'location',
    PERSONID: 'personId',
    FAILURES: 'failures',
    LOGINS: 'logins',
    BARCODE: 'barcode',
    BARCODES: 'barcodes',
    BADGE_COLOR: 'badgeColor',
    MANAGER: 'manager',
    IS_MANAGER: 'isManager',
    MANAGER_FIRST_NAME: 'managerFirstName',
    MANAGER_LAST_NAME: 'managerLastName',
    ENCODED_BADGE_PHOTO: 'encodedBadgePhoto',
    IMG_URL: 'imgURL',
    DEVICE_NAME: 'deviceName',
    EVENT_TIMESTAMP: 'eventTimestamp',
    PUNCH_EVENT_TIMESTAMP: 'punchEventTimestamp',
    JOB_LEVEL: 'jobLevel',
    IMT_ROLE: 'imtRole',
    IMT_IS_PRIMARY: 'imtIsPrimary',
    IMT_LOCKED: 'imtLocked'
};

export const RESPONDER_STRINGS = {
    EMPLOYEE_INFORMATION: 'Employee Information',
    MANAGER_INFORMATION: 'Manager Information',
    MANAGER: 'Manager',
    MANAGER_ALIAS: 'Manager alias',
    BADGE: 'Badge',
    TIMECARD: 'Timecard',
    LAST_BADGE_POINT: 'Last badge point',
    LAST_BADGE_TIME: 'Last badge time',
    LAST_PUNCH_TIME: 'Last punch time',
    SEE_ALL: 'See all',
    MAIN_TITLE: 'On-Site Emergency Responders',
    IMT_SECTION_TITLE: 'Incident Management Team (IMT)',
    WHS_SECTION_TITLE: 'Workplace, Health, and Safety (WHS)',
    FIRST_RESPONDERS_SECTION_TITLE: 'First Responders',
    FIRST_AIDERS_SECTION_TITLE: 'First Aiders',
    FIRE_MARSHALS_SECTION_TITLE: 'Fire Marshals',
    IMT: 'imt',
    WHS: 'whs',
    FIRST_RESPONDERS: 'firstResponders',
    FIRST_AIDERS: 'firstAiders',
    FIRE_MARSHALS: 'fireMarshals',
    MAXIMUM_SITES: 5,
    INVALID_SEARCH_LENGTH: 2,
    SITE_POPOVER_MESSAGE: 'You cannot add more than 5 sites at a time.',
    WAIT_MESSAGE: 'This may take a few seconds.',
    NO_INFO_MAIN: 'No information to present',
    PAGE_INFO_MESSAGE: `This report is being pulled from Facility Manager's sections "On-Site Emergency Responder", IMT and WHS groups. Please update the same to refresh the data in RallyPoint.`,
    NO_RESULT_BASE_MESSAGE: 'The filters that are being applied do not have data associated to them',
    NO_RESULT_AVAILABLE_MESSAGE:
        'Select one of the facilities above to view the Emergency Response Dashboard.',
    DISPLAY_FULLSCREEN: 'Display Full Screen',
    EXPORT: 'Export',
    FULL_EXPORT: 'Export all data',
    FILTERED_EXPORT: 'Export data as displayed',
    GO_BACK: 'Go back'
};

export const PII_MASK = '******';

export const DATA_GRID_COMMON_TEXT_STYLES = {
    fontFamily: 'Inter',
    textTransform: 'capitalize'
};

export const DATA_GRID_COMMON_COMPONENTS_PROPS_STYLES = {
    filterPanel: {
        linkOperators: [],
        filterFormProps: {
            operatorInputProps: {
                disabled: true,
                sx: { display: 'none' }
            }
        }
    },
    panel: {
        sx: {
            '& .MuiTypography-root': DATA_GRID_COMMON_TEXT_STYLES,
            '& .MuiButton-text': DATA_GRID_COMMON_TEXT_STYLES,
            '& .MuiInputBase-root': DATA_GRID_COMMON_TEXT_STYLES,
            '& .MuiFormLabel-root': DATA_GRID_COMMON_TEXT_STYLES
        }
    },
    footer: {
        sx: {
            '& .MuiToolbar-root': DATA_GRID_COMMON_TEXT_STYLES,
            '& .MuiSelect-select': DATA_GRID_COMMON_TEXT_STYLES,
            '& .MuiTablePagination-selectLabel': { ...DATA_GRID_COMMON_TEXT_STYLES, marginTop: '14px' },
            '& .MuiTablePagination-displayedRows': { ...DATA_GRID_COMMON_TEXT_STYLES, marginTop: '14px' }
        }
    }
};

export const DATA_GRID_COMMON_SX_STYLES = {
    '& .MuiDataGrid-columnHeaderTitleContainer': {
        ['& .MuiDataGrid-columnHeaderTitle']: {
            fontSize: '0.8rem',
            fontWeight: '600',
            overflow: 'visible',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            lineHeight: '1.1'
        }
    },
    '& .MuiDataGrid-row': {
        fontSize: '0.8rem',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        ['& .MuiDataGrid-cell']: {
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'normal'
        }
    },
    '& .MuiDataGrid-row:not': {
        fontSize: '0.8rem',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        ['& .MuiDataGrid-cell']: {
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'normal'
        }
    },
    '& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell': {
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        lineHeight: '1.1'
    },
    '& .MuiButton-text': {
        fontFamily: 'Inter, sans-serif',
        textTransform: 'capitalize',
        fontWeight: '400',
        color: '#0D4AFF'
    },
    '& .MuiDataGrid-columnHeader': {
        fontFamily: 'Inter, sans-serif',
        textTransform: 'capitalize',
        fontWeight: '400'
    },
    '& .MuiDataGrid-cell': {
        fontFamily: 'Inter, sans-serif',
        fontWeight: '400'
    },
    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '10px' },
    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '14px' },
    border: '2px solid #EAECF0',
    borderRadius: '10px',
    padding: '10px 10px 10px 10px'
};

export const IMT_CMT_ROLES = {
    OPS: 'OPS',
    LP: 'LP',
    PXT: 'PXT',
    RME: 'RME',
    FINANCE: 'Finance',
    WHS: 'WHS'
};

export const IMT_CMT_ROLES_LOWER = {
    OPS: 'ops',
    LP: 'lp',
    PXT: 'pxt',
    RME: 'rme',
    FINANCE: 'finance',
    WHS: 'whs'
};

export const RESPONDER_SITE_URL_SEPARATOR = '+';

export const IMT_LEGACY_OPS_TITLES = new Set([
    'director, regional operations',
    'regional director operations',
    'director, operations',
    'general manager',
    'general manager, operations',
    'site leader',
    'sr. operations manager',
    'senior operations manager',
    'regional site manager',
    'senior station manager',
    'sr. station manager',
    'senior regional manager',
    'snr delivery station manager',
    'operations manager',
    'pathways operations manager',
    'learning operations manager',
    'delivery station manager',
    'l5 area manager ii',
    'area manager',
    'pathways area manager',
    'gm administrative assistant',
    'lead',
    'shift manager'
]);

export const OPS_TITLE_KEYWORDS = [
    'ops',
    'operations',
    'gm',
    ['area', 'manager'],
    ['station', 'manager'],
    ['general', 'manager'],
    ['shift', 'manager'],
    ['regional', 'manager'],
    ['pathways', 'manager'],
    ['site', 'manager'],
    ['site', 'lead'],
    ['site', 'leader']
];

export const EVENT_STATUS_TYPE_SELECT_OPTIONS = [
    {
        label: 'All',
        value: 'all'
    },
    {
        label: 'Start',
        value: 'open'
    },
    {
        label: 'Complete',
        value: 'close'
    },
    {
        label: 'Reopen',
        value: 'reopen'
    },
    {
        label: 'End',
        value: 'end'
    }
];

export const EVENT_STATUS_LIST = ['open', 'close', 'reopen', 'end'];

export const EVENT_STATUS_TYPES = {
    OPEN_EVENT: 'openEvent',
    CLOSE_EVENT: 'closeEvent',
    REOPEN_EVENT: 'reopenEvent',
    END_EVENT: 'endEvent'
};

export const EMAIL_GROUP_TYPES = {
    TEAM: 'team',
    EMAIL_LIST: 'emailList'
};

export const EVENT_STATUS_MAP = {
    openEvent: 'open',
    closeEvent: 'close',
    reopenEvent: 'reopen',
    endEvent: 'end'
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DO_NOT_REMOVE_EMAIL_NOTIFICATIONS_LIST = [
    'rallypoint-gamma@gsoc.wwos.amazon.dev',
    'rallypoint@gsoc.wwos.amazon.dev'
];
